// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken as getMessagingToken } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC7oi90muU7ib-R7I7iyxa1pjQwx1-RMr4",
  authDomain: "pushnotificationsww.firebaseapp.com",
  projectId: "pushnotificationsww",
  storageBucket: "pushnotificationsww.firebasestorage.app",
  messagingSenderId: "487688208730",
  appId: "1:487688208730:web:eef238234c0cb5bc63b363",
  measurementId: "G-5BV866CJ0Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);


const getToken = async () => {
  try {
    const currentToken = await getMessagingToken(messaging, { vapidKey: "BGjpNePomY3pqHRX0T2qZ7KzX3ahcHyCRAdhC_q9xN-2Xrd7YKfvzkYJdr4rKrmGRvHvP3A7wQ2siReNom3oKiM" });
    if (currentToken) {
      console.log("Token obtenido:", currentToken);
      return currentToken;
    } else {
      console.warn("No se obtuvo token. Se necesita permiso.");
      return null;
    }
  } catch (err) {
    console.error("Error al obtener el token", err);
    return null;
  }
};

export { getToken };
